// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2UWvG","box":"WorkspacesBox_box__39J3_","node":"WorkspacesBox_node__16DBC"};